<template>
    <div class="groupShopShar" ref="groupShopShar">
        <mu-appbar class="head">
          <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>        
          <p class="title">{{pintuanInfo.ProductName}}</p>
          <mu-icon-menu icon=":fa fa-more" slot="right">
            <mu-menu-item to="/usercenter/index" title="个人中心"/>
            <mu-menu-item to="/" title="首页"/>
            <mu-menu-item to="/retail/cart" title="购物车"/>
          </mu-icon-menu>
        </mu-appbar>
        <div style="background: #fff;">
          <mu-list-item class="invite_product">
            <div class="product_item">
                <router-link to="">
                  <img :src="pintuanInfo.ImagePath" class="proImg" alt=""> 
                  <div class="product_info" :style="{width: proItemInfoWidth +'px'}">
                      <div class="product_title">
                          <span class="slaePrice">{{pintuanInfo.ZheKou}}折</span>
                          <span class="prime_cost">指导价{{pintuanInfo.OldPrice}}元</span>
                          {{pintuanInfo.ProductName}}
                      </div>
                      <div class="sign">
                        <div class="shopNum sign">{{pintuanInfo.FgroupNumber}}人团</div>
                        <div class="free_post sign" v-if="!productInfo.IsFreight">包邮</div>
                      </div> 
                      
                      <div class="price_time">
                          <p class="price">拼团价<span>{{pintuanInfo.Fprice}}</span>元</p>
                          <p class="sellCount">已团{{pintuanInfo.FcountJoinGroup}}件</p>
                      </div>
                  </div>       
                </router-link>  
            </div>
        </mu-list-item>
        <div class="invite">
          <p class="inviteCount" v-if="pintuanInfo.FjoinGroupList && parseInt(pintuanInfo.FremainingNum)>0">
            再邀请 <span style="color: red;">{{parseInt(pintuanInfo.FremainingNum)}}</span> 人拼单成功
          </p>
          <p class="inviteCount" v-if="parseInt(pintuanInfo.FremainingNum)==0">
              <span style="color: red;">拼单完成，成团成功</span>
          </p>
          <div class="inviteImg">
            <div class="clonel" v-for="(joinItem,jItem) in pintuanInfo.FjoinGroupList" :key="jItem">
              <img :src="joinItem.Fminnerbm" alt="">
              <p class="tuanzhang" v-if="joinItem.FisColonel == '1'">团长</p>
            </div>
            
            <mu-icon value=":fa fa-mycicle1" style="color:#ccc;" :size="50" v-for="i in parseInt(pintuanInfo.FremainingNum)" :key="i" />
          </div>
        </div>
        <div v-if="parseInt(pintuanInfo.FremainingNum)>0">
          <mu-raised-button @click="openShareSheet()" label="邀请好友拼单" class="demo-raised-button invite_botton" secondary v-if="pintuanInfo.FisJoinGroup == '1'" />
          <mu-raised-button @click="openGroupSheet"  label="我要参团" class="demo-raised-button invite_botton" secondary v-if="pintuanInfo.FisJoinGroup == '0' && isCanTuan" />
          <mu-raised-button label="已失效" disabled class="demo-raised-button uninvite_botton" secondary v-if="pintuanInfo.FisJoinGroup == '0' && !isCanTuan" />
          <div class="inviteTime" >{{payOverDateName}}</div>
        </div>
        
        <div v-if="parseInt(pintuanInfo.FremainingNum)==0">
          <mu-raised-button label="成团成功" disabled class="demo-raised-button uninvite_botton" />
        </div>
        <div class="orderStep">
            <img src="/static/orderStep.png" alt="">
        </div>
       </div>
      
      <template  v-for="(otherItem,index) in pintuanInfo.Flist">
        <mu-list v-if="otherItem && otherItem.Flist" :key="index">
          <div class="list_item">
              <div class="itemTop">
                <div class="itemTitle">
                  <p class="activeName">{{otherItem.Fname}}</p> 
                  <p class="time">距离结束 <span>{{otherItem.FremainingTime}}</span> </p>
                </div>
                <div class="topRight">
                  <p class="peopleCount">{{otherItem.FcountJoinGroup}}人正在拼</p>
                  <mu-avatar :src="headItem" class="zindexOne" slot="leftAvatar" v-for="(headItem,index) in otherItem.FUserHeadList" :key="index" />                 
                 
                </div>
              </div>
              <mu-list-item class="product" v-for="(proItem,pIndex) in otherItem.Flist" :key="pIndex">
                  <div class="product_item" >
                     <router-link to="">
                        <img :src="proItem.ImagePath" class="proImg" alt=""> 
                        <div class="product_info" :style="{width: proItemInfoWidth +'px'}">
                            <div class="product_title">
                                <span class="slaePrice">{{proItem.ZheKou}}折</span>
                                <span class="prime_cost">指导价{{proItem.OldPrice}}元</span>
                                {{proItem.ProductName}}
                            </div>
                            <div class="sign">
                              <div class="shopNum sign">{{otherItem.FgroupNumber}}人团</div>
                              <div class="free_post sign" v-if="!proItem.IsFreight">包邮</div>
                            </div> 
                            <div class="price_time">
                                <p class="price">拼团价<span>{{proItem.FminSkuPrice}}</span>元</p>
                                <p class="sellCount">已团{{proItem.FcountJoinGroup}}件</p>
                            </div>
                            <div class="num_goshop">         
                                <mu-raised-button label="去拼团" :to="'/retail/productDetail?skuId='+proItem.FminSkuId+'&activityId='+otherItem.Fid" class="demo-raised-button"/>
                            </div>
                        </div>                     
                     </router-link>  
                  </div>
              </mu-list-item>
          </div>
        </mu-list>
      </template>
      <XR-toast ref="XRtoast"></XR-toast>
      
      <mu-bottom-sheet :open="shareSheet" @close="closeShareSheet">    
        <div class="groupShopShar-shareSheetTitle">分享到</div>
        <div class="groupShopShar-shareSheetWayList">
          <div class="shareSheetWayItem" @click="appWeChatFringtShareClick">
            <div class="shareWayIcon wechatFrind"><i class="fa fa-wechat"></i></div>
            <div class="shareWayText">微信好友</div>
          </div>
          <div class="shareSheetWayItem" @click="appWeChatFringtQuanShareClick">          
            <div class="shareWayIcon wechatFrindQuan"><i class="fa fa-diamonds"></i></div>
            <div class="shareWayText">朋友圈</div>
          </div>
        </div>   
      </mu-bottom-sheet>

      <mu-bottom-sheet :open="GroupSheet" @close="closeGroupSheet">    
        <div class="groupShopShar-skuSaleInfo">
          <div class="pro-img">
            <img :src="productInfo.ImgList && productInfo.ImgList.length>0?productInfo.ImgList[0].ImgPath: IMGServer_URL+'/images/index-item-default.png'" class="img" />
          </div>
          <div class="info">
            <p class="price">￥{{nowPinTuanInfo.Fprice}}</p>
            <p class="stock">库存：{{nowPinTuanInfo.Fstock}}</p>
          </div>
        </div>   
        <div style="clear:both;"></div>  
        <div class="groupShopShar-scroll">            
          <div class="groupShopShar-attrList">            
            <div class="attr" v-for="attr in productInfo.AttrList" :key="attr.Id">
              <div class="attrName">{{attr.Name}}</div>
              <div class="attrValueList">
                <div :class="'attrValue '+getSkuClassSelect(attr.Id,attrValue.Id)" v-for="attrValue in attr.Values" :key="attrValue.Id" @click="skuTab(attr.Id,attrValue.Id)">
                  <template v-if="attr.AttrType==1 && attrValue.IconPath"><img :src="imgServerUrl+'/api/img/getPath?id='+attrValue.IconPath" class="attrIcon" /></template>
                  <template v-if="attr.AttrType==3 && attrValue.Color"><span class="attrIcon" :style="{background:attrValue.Color}" ></span></template>
                  <span class="attrValueText">{{attrValue.Name}}</span>
                </div>
              </div>
            </div>
          </div>   
          <div class="groupShopShar-jiajian">
            <div class="groupShopShar-jiajian-ctrl">
              <span class="btn jian" @click="minusCartItem(productInfo.SkuId, productInfo.Stock)">-</span>
              <span class="count">{{skuCount}}</span>
              <span class="btn jia" @click="plusCartItem(productInfo.SkuId, productInfo.Stock)">+</span>
            </div>
          </div>
        </div>
        <div class="groupShopShar-btn" @click="joinGroup()">            
          <div class="btn">我要参团</div>
        </div>
      </mu-bottom-sheet>
      <div class="modal" v-show='modalShow'>
          <img class="jiantou" src="/static/suggetstion/4.png" alt="">
          <p >请点击右上角进行分享</p>
          <img @click="closemodal"src="/static/suggetstion/5.png" alt="">
      </div>
      <div class="erweima" @click="erweimaHidden()" v-show ='erweimaShow'>
        <div class="erweima_list">
          <div class="erweima_item">
            <img src="/static/erweima/xurigo_erweima.jpg" alt="">
            <p class="tishi">关注公众号</p>
          </div>
          <div class="erweima_item">
            <img src="/static/erweima/baw_erweima.png" alt="">
            <p class="tishi">更多体验，请下载baw App</p>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import appShare from '../../util/appShare'
import wechatCache from '../../util/wechatCache'
export default {
  data() {
    return {
      proItemInfoWidth: (parseInt(document.documentElement.clientWidth)-137),
      GroupSheet:false,
      skuCount:1,
      modalShow:false,
      erweimaShow:false,
      time:[],
      minnerbm:'',
      sku: this.$route.query.skuId,
      skuId:0,
      groupId:this.$route.query.groupId,
      pintuanInfo:{},     
      nowPinTuanInfo:{}, 
      shareSheet:false,
      shareTitle:'',
      shareDesc:'',
      shareImgUrl:'',
      shareLinkUrl:'',
      productInfo:{},
      skuTabList:[],
      pinTuanSkuList:[],
      totalSpan:0,
      payOverDateName:'00:00:00',
      isCanTuan: false
    }
  },
  mounted() {
    this.getInfo()
  },
  created() {
    
  },
  methods: {    
    calcPayOverDate(tmpTime){   
      var ths = this

      var hour = tmpTime.split(':')[0];
      var min = tmpTime.split(':')[1];
      var sec = tmpTime.split(':')[2];
      ths.totalSpan = Number(hour*3600) + Number(min*60) + Number(sec);  
      var interval = setInterval(function(){
        ths.totalSpan = ths.totalSpan-1    
        if (ths.totalSpan <= 0) {
          ths.isCanTuan = false
          ths.payOverDateName=''
          clearInterval(interval);
          return;
        }else{
          ths.isCanTuan = true
        }
        var hh = parseInt(ths.totalSpan  / 60 / 60, 10); //计算剩余的小时数  
        var mm = parseInt(ths.totalSpan  / 60 % 60, 10); //计算剩余的分钟数  
        var ss = parseInt(ths.totalSpan  % 60, 10); //计算剩余的秒数 

        if(hh<10){
          hh= '0'+hh
        }
        if(mm<10){
          mm= '0'+mm
        }
        if(ss<10){
          ss= '0'+ss
        }
        ths.payOverDateName = hh+'时'+mm+"分"+ss+'秒后失效'   
      },1000)
    },
    GoHistory(){
      this.$router.goBack()
    },
    openGroupSheet(){
      this.GroupSheet = true
    },
    closeGroupSheet(){
      this.GroupSheet = false
    },
    plusCartItem: function(){
      if(this.skuCount ==10){
        this.$refs.XRtoast.failed("不能再加了", true);
        return;
      }
      this.skuCount++ 
    },
    closeShareSheet () {
      this.shareSheet = false
    },
    closemodal(){
      this.modalShow = false

    },
    openShareSheet () {
      var ua = window.navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i)=="micromessenger") {
        this.modalShow = true
      }else{        
        var appClient = window.localStorage.appClient
        if(appClient==undefined){
          this.erweimaShow  = true
        }else if(appClient == 'ios' || appClient == 'android'){      
          //window.webkit.messageHandlers.ajax.postMessage({fun:'share',Ftitle: this.shareTitle,Fimage:this.shareLinkUrl ,FjumpUrl: this.shareLinkUrl})
        //}else{
          this.shareSheet = true
        }
      }
    },
    erweimaHidden(){
      this.erweimaShow = false
    },
    openShare(){
        this.shareSheet = true
    },
    appWeChatFringtShareClick(){
      appShare.shareWeChatFriend(this.shareTitle,this.shareDesc,this.shareImgUrl,this.shareLinkUrl)
    },    
    appWeChatFringtQuanShareClick(){
      appShare.shareWeChatFriendQuan(this.shareTitle,this.shareDesc,this.shareImgUrl,this.shareLinkUrl)
    },
    minusCartItem: function(){
      if(this.skuCount == 1){
        this.$refs.XRtoast.failed("不能再减了", true);
        return;
      }
      this.skuCount--
    },
    getInfo(){   
      var ths = this;   
      ths.$post(
        "/Shop/PinTuanServer/WapActivityShare",
        JSON.stringify({sku: this.sku, groupId: this.groupId})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.pintuanInfo = res.Data
          ths.nowPinTuanInfo = {Fprice: ths.pintuanInfo.Fprice, Fstock: ths.pintuanInfo.Fstock}
          ths.shareTitle = res.Data.FshareTitle
          ths.shareDesc = res.Data.FshareDescribe
          ths.shareImgUrl = res.Data.FshareImage
          ths.shareLinkUrl = window.location.href
          
          ths.pinTuanSkuList = res.Data.FskuList
          ths.activityid = res.Data.Factivityid
          ths.skuId = res.Data.Fskuid
          ths.calcPayOverDate(ths.pintuanInfo.FremainingTime)
          //ths.calcPayOverDate('00:00:05')
          ths.getProductDetail()
          ths.initWeiXin()
        }
      });
    },
    
    getProductDetail:function(){
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/GetProductDetail",
        JSON.stringify({skuId:this.skuId})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.productInfo = res.Data
          if(ths.productInfo.AttrList){
            for(var i = 0; i< ths.productInfo.AttrList.length;i++){
              var attr = ths.productInfo.AttrList[i]
              var attrSelect = {}
              attrSelect.attrId = attr.Id
              attrSelect.isClick = 0
              for(var j = 0; j< attr.Values.length;j++){
                var attrValue = attr.Values[j]
                if(attrValue.IsSkuValue==1){
                  attrSelect.attrValueId = attrValue.Id
                }
              }
              ths.skuTabList.push(attrSelect)
            }
          }
        }
      });
    },    
    getSkuClassSelect(attrId, attrValueId){
      for(var i = 0; i< this.skuTabList.length;i++){
        var sku = this.skuTabList[i]
        if(attrId == sku.attrId && attrValueId == sku.attrValueId){
          return 'select'
        }
      }
    },
    
    skuTab(attrId, attrValueId){
      var isTab = false
      for(var i = 0; i< this.skuTabList.length;i++){
        var sku = this.skuTabList[i]
        if(attrId == sku.attrId){
          sku.isClick= 1
          if(attrValueId == sku.attrValueId){
            continue
          }
          sku.attrValueId = attrValueId
          isTab = true
        }else{
          sku.isClick= 0
        }
      }
      if(isTab){
        var ths = this;   
        ths.$post(
          "/Shop/RetailServer/GetSkuByAttrValue",
          JSON.stringify({ productId:this.productInfo.ProductId, attrValues: this.skuTabList})
        ).then(function(res) {
          if(!res.IsSuccess){
            ths.$refs.XRtoast.failed(res.Msg, true)
          }else{               
            ths.skuId=res.Msg
            for(var i = 0; i < ths.pinTuanSkuList.length; i++){
              if(ths.skuId == ths.pinTuanSkuList[i].Fskuid){
                ths.nowPinTuanInfo = {Fprice: ths.pinTuanSkuList[i].Fprice, Fstock: ths.pinTuanSkuList[i].Fstock}
                ths.sku = ths.pinTuanSkuList[i].Fid
              }
            }

            ths.getProductDetail()
          }
        });
      }
    },    
    joinGroup(){
      this.$router.push('/groupShop/groupShopSubmit?skuId='+this.productInfo.SkuId+'&activityId='+this.activityid+'&groupId='+this.groupId+'&count='+this.skuCount)
    },
    
    initWeiXin(){
      var ths = this;   
      
      var openId = wechatCache.getOpenId()
      if(!openId){
        //this.$refs.XRtoast.failed('未获取微信信息', true)
        return
      }

      ths.$postBase(
      ths.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{   
          
          ths.$refs.XRtoast.hide()
          ths.loaded= false
          
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {              
              wx.onMenuShareTimeline({
                  title: ths.shareTitle, // 分享标题
                  link: ths.shareLinkUrl, // 分享链接
                  imgUrl: ths.shareImgUrl, // 分享图标
                  success: function () {
                  },
                  cancel: function () {
                      // 用户取消分享后执行的回调函数
                  }
              });

              wx.onMenuShareQQ({
                  title: ths.shareTitle, // 分享标题
                  desc: ths.shareDesc, // 分享描述
                  link: ths.shareLinkUrl, // 分享链接
                  imgUrl: ths.shareImgUrl, // 分享图标
                  success: function () {
                  },
                  cancel: function () {
                      // 用户取消分享后执行的回调函数
                  }
              });

              wx.onMenuShareAppMessage({
                  title: ths.shareTitle, // 分享标题
                  desc: ths.shareDesc, // 分享描述
                  link: ths.shareLinkUrl, // 分享链接
                  imgUrl: ths.shareImgUrl, // 分享图标
                  success: function () {
                  },
                  cancel: function () {
                      // 用户取消分享后执行的回调函数
                  }
              });
              wx.onMenuShareQZone({
                  title: ths.shareTitle, // 分享标题
                  desc: ths.shareDesc, // 分享描述
                  link: ths.shareLinkUrl, // 分享链接
                  imgUrl: ths.shareImgUrl, // 分享图标
                  success: function () {
                      // 用户确认分享后执行的回调函数
                  },
                  cancel: function () {
                      // 用户取消分享后执行的回调函数
                  }
              });
          });
      }
      }); 
    },    
  }
};
</script>
<style>
  .groupShopShar .head .title{
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .groupShopShar .invite_product{
    border-bottom: 1px solid #f5f5f5
  }
  .groupShopShar  .invite_product .product_item .proImg{
    width: 95px;
    float: left;
    background: white;
    height: 95px;
  }
  .groupShopShar  .invite_product .product_item .product_info{
    float: right;
    margin-left: 10px;
  }
  .groupShopShar  .invite_product .product_item .product_info .product_title{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 14px;
    color: #000;
  }
  .groupShopShar  .invite_product .product_item .product_info .product_title .slaePrice{
    color: red;
    font-weight: bold;
  }
  .groupShopShar  .invite_product .product_item .product_info .product_title .prime_cost{
    color: #666;
  }
  .groupShopShar  .invite_product .product_item .product_info .sign{
    text-align: center;
    border-radius: 2px;
    color: #fff;
    font-size: 12px;
    padding: 1px 0;
    overflow: hidden;
  }
  .groupShopShar  .invite_product .product_item .product_info .sign .shopNum{
    background: #EB4D54;
    width: 40px;
    border-radius: 5px;
    margin-right: 10px;
    float: left;
  }
  .groupShopShar  .invite_product .product_item .product_info .sign .free_post{
    float: left;
    width: 40px;
    border-radius: 5px;
    margin-right: 10px;
    background: #CC9137;
  }
  .groupShopShar  .invite_product .product_item .product_info .price_time{
    float: left;
  }
  .groupShopShar  .invite_product .product_item .product_info .num_goshop{
    float: right;
  }
  .groupShopShar  .invite_product .product_item .product_info .price_time .price{
    color: #C13B38;
    font-size: 14px;
    line-height: 20px;
    height: 20px;
    margin-top: 11px;
  }
  .groupShopShar  .invite_product .product_item .product_info .price_time .price span{
    font-size: 20px;
    padding: 0 5px;
  }
  .groupShopShar  .invite_product .product_item .product_info .price_time .sellCount{
    font-size: 14px;
    color: #999;
    text-align: left;
  }
  .groupShopShar  .invite_product .product_item .product_info .num_goshop .mu-raised-button{
    min-width: 60px;
    height: 25px;
    margin-top: 13px;
    background: #C13B38;
    color: #fff;
  }
  .groupShopShar .invite{
    padding: 0 16px;
    margin-top: 25px;
  }
  .groupShopShar .invite .inviteCount{
    text-align: center;
    font-size: 16px;
  }
  .groupShopShar .invite .inviteImg{
    text-align: center;
    margin-top: 10px;
  }
  .groupShopShar .invite .inviteImg .clonel{
    width: 44px;
    height: 44px;
    border: 1px solid #FAC424;
    position: relative;
    display: inline-block;
    text-align: center;
    margin-right: 4px;
    border-radius: 50%;
  }
  .groupShopShar .invite .inviteImg .clonel img{
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
  .groupShopShar .invite .inviteImg .tuanzhang{
    position: absolute;
    left: -5px;
    top: -5px;
    color: #CA8F10;
    background: #FAC424;
    border-radius: 10px 10px;
    padding: 0 3px;
    font-size: 12px;
  }
  .groupShopShar .invite_botton{
    background: #AD0E11;
    width: 100%;
    height: 45px;
    margin-top: 25px;
  }
  .groupShopShar .invite_botton .mu-raised-button-label{
    font-size: 16px;
  }
  .groupShopShar .uninvite_botton{
    background: #eee;
    width: 100%;
    height: 45px;
    margin-top: 25px;
  }
  .groupShopShar .uninvite_botton .mu-raised-button-label{
    font-size: 16px;
    color:#999;
  }
  .groupShopShar .inviteTime{
    color: #999;
    font-size: 12px;
    margin-top: 5px;
    text-align: center;
  }
  .groupShopShar .orderStep{
    padding: 0 16px;
    margin-top: 20px;
    height: 60px;;
    display: flex;
    align-items: center;
    border-top: 1px solid #f5f5f5;
  }
  .groupShopShar .orderStep img{
    width: 100%;
  }
  /* .groupShopShar .orderStep .step_num{
    width: 15px;
    height: 15px;
    color: #fff;
    background: #666;
    border-radius: 50%;
    font-size: 12px;
    text-align: center;
    line-height: 15px;
  }
  .groupShopShar .orderStep .stepOne{
    font-size: 14px;
    padding-left: 3px;
  } */

  .groupShopShar .mu-list{
    
    padding: 0;
    margin-top: 15px;
  }
  .groupShopShar .mu-list .list_item{
    margin-top: 15px;
    padding: 10px 0;
    background: #fff;
  }
  .groupShopShar .mu-list .list_item:first-child{
    margin: 0;
  }
  .groupShopShar .mu-list .list_item .itemTop{
    overflow: hidden;
    padding: 0 16px;
  }
  .groupShopShar .mu-list .list_item .itemTop .itemTitle{
    float: left;
    font-size: 16px;
    width: 40%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 50px;
  }
  .groupShopShar .mu-list .list_item .itemTop .itemTitle .activeName{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .groupShopShar .mu-list .list_item .itemTop .itemTitle .time{
    font-size: 12px;
    color: #999;
  }
  .groupShopShar .mu-list .list_item .itemTop .itemTitle .time span{
    padding-left: 5px;
    color: #DEAAA7;
  }
  .groupShopShar .mu-list .list_item .itemTop .topRight{
    float: right;
    display: flex;
    align-items: center;
    background: #FEF2F9;
    width: auto;
    padding: 0 5px;
    border-radius: 15px;
    position: relative;
    height: 30px;
    padding-right: 60px;
    margin-top: 5px;
  }
  .groupShopShar .mu-list .list_item .itemTop .topRight .peopleCount{
    font-size: 14px;
    color: red;
    padding-right: 5px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .groupShopShar .mu-list .list_item .itemTop .topRight .mu-avatar{
    width: 23px;
    height: 23px;
    position: absolute;
    background: #fff;
    border-radius: 50%; 
  }
  .groupShopShar .mu-list .list_item .itemTop .topRight .zindexOne:nth-child(2){
    right: 5px;
  }
  .groupShopShar .mu-list .list_item .itemTop .topRight .zindexOne:nth-child(3){
    right: 20px;
  }
  .groupShopShar .mu-list .list_item .itemTop .topRight .zindexOne:nth-child(4){
    right: 35px;
  }
  .groupShopShar .mu-list .list_item .product .product_item .proImg{
    width: 95px;
    float: left;
    background: white;
    height: 95px;
  }
  .groupShopShar .mu-list .list_item .product .product_item .product_info{
    float: right;
    margin-left: 10px;
  }
  .groupShopShar .mu-list .list_item .product .product_item .product_info .product_title{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 14px;
    color: #000;
  }
  .groupShopShar .mu-list .list_item .product .product_item .product_info .product_title .slaePrice{
    color: red;
    font-weight: bold;
  }
  .groupShopShar .mu-list .list_item .product .product_item .product_info .product_title .prime_cost{
    color: #666;
  }
  .groupShopShar .mu-list .list_item .product .product_item .product_info .sign{
    text-align: center;
    border-radius: 2px;
    color: #fff;
    font-size: 12px;
    padding: 1px 0;
    overflow: hidden;
  }
  .groupShopShar .mu-list .list_item .product .product_item .product_info .sign .shopNum{
    background: #EB4D54;
    width: 40px;
    border-radius: 5px;
    margin-right: 10px;
    float: left;
  }
  .groupShopShar .mu-list .list_item .product .product_item .product_info .sign .free_post{
    float: left;
    width: 40px;
    border-radius: 5px;
    margin-right: 10px;
    background: #CC9137;
  }
  .groupShopShar .mu-list .list_item .product .product_item .product_info .price_time{
    float: left;
  }
  .groupShopShar .mu-list .list_item .product .product_item .product_info .num_goshop{
    float: right;
  }
  .groupShopShar .mu-list .list_item .product .product_item .product_info .price_time .price{
    color: #C13B38;
    font-size: 14px;
  }
  .groupShopShar .mu-list .list_item .product .product_item .product_info .price_time .price span{
    font-size: 20px;
    padding: 0 5px;
  }
  .groupShopShar .mu-list .list_item .product .product_item .product_info .price_time .sellCount{
    font-size: 14px;
    color: #999;
    text-align: left;
  }
  .groupShopShar .mu-list .list_item .product .product_item .product_info .num_goshop .mu-raised-button{
    min-width: 60px;
    height: 25px;
    margin-top: 13px;
    background: #C13B38;
    color: #fff;
  }
  .groupShopShar-skuSaleInfo {
  height: 75px;
}
.groupShopShar-skuSaleInfo .pro-img{
  float: left;
}
.groupShopShar-skuSaleInfo .img{
  margin-top:-15px;
  margin-left: 15px;
  border: 1px solid #eee;
  border-radius: 5px;
  width: 80px;
  display: block;
}
.groupShopShar-skuSaleInfo .info{  
  float: left;
  padding: 20px 0 0 15px;
}
.groupShopShar-skuSaleInfo .info .price{  
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color:Red;
}
.groupShopShar-skuSaleInfo .info .skuid{ 
  font-size: 12px;
}
.groupShopShar-btn .btn{
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: red;
  color: white;
}
.groupShopShar-attrList .attr{
  border-top: 1px solid #eee;
  padding: 0 10px;
}
.groupShopShar-attrList .attr .attrName{
  line-height: 34px;
}
.groupShopShar-attrList .attr .attrValueList{
  overflow: hidden;
}
.groupShopShar-attrList .attr .attrValueList .attrValue{
  float: left;
  padding: 5px 20px;
  margin: 0 10px 10px 0;
  background: #eee;
  border-radius: 5px;
  overflow: hidden;
}
.groupShopShar-attrList .attr .attrValueList .attrValue .attrIcon{
  width: 20px;
  height: 20px;
  margin-right:5px;
  float: left;
}
.groupShopShar-attrList .attr .attrValueList .attrValue .attrValueText{
  float: left;
}
.groupShopShar-attrList .attr .attrValueList .attrValue.disabled{
  background: #eee;
  color:#ddd;
}
.groupShopShar-attrList .attr .attrValueList .attrValue.select{
  background: red;
  color:white;
}
.groupShopShar-attrList .attr .attrValueList .attrValue.select .attrIcon{
  border:1px solid white;
}
.groupShopShar-jiajian{
  overflow: hidden;
}
.groupShopShar-jiajian-ctrl{
  padding: 20px 10px;
  float: right;
}
.groupShopShar-jiajian-ctrl span{
  float: left;
  width: 20px;
  text-align: center;
}
.groupShopShar-jiajian-ctrl .count{
  border: 1px solid #eee;
  width: 30px;
  border-left: 0;
  border-right: 0;
}
.groupShopShar-jiajian-ctrl .btn{
  border: 1px solid #eee;
}
.groupShopShar-jiajian-ctrl .jian{
  border-radius:2px 0 0 2px;
}
.groupShopShar-jiajian-ctrl .jia{
  border-radius:0 2px 2px 0;
}
.groupShopShar-btn .btn{
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: red;
  color: white;
}


.groupShopShar-shareSheetTitle {
  line-height: 40px;
  font-size: 16px;
  padding: 20px 20px 0;
}
.groupShopShar-shareSheetWayList {
  overflow: hidden;
}
.groupShopShar-shareSheetWayList .shareSheetWayItem {
  float: left;
  padding: 20px;
  width: 100px;
  text-align: center;
}
.groupShopShar-shareSheetWayList .shareSheetWayItem .shareWayIcon {
  font-size: 28px;
  border-radius: 50%;
  width:45px;
  height:45px;
  line-height: 45px;
  text-align: center;
  color:white;
  display: inline-block;
}
.groupShopShar-shareSheetWayList .shareSheetWayItem .shareWayIcon.wechatFrind{
  background: #07BD13;
}
.groupShopShar-shareSheetWayList .shareSheetWayItem .shareWayIcon.wechatFrindQuan{
  background: #99D021;
}
.groupShopShar-shareSheetWayList .shareSheetWayItem .shareWayText {
  padding-top: 10px;
}
.groupShopShar-skuSaleInfo {
  height: 75px;
}
.groupShopShar-skuSaleInfo .pro-img{
  float: left;
}
.groupShopShar-skuSaleInfo .img{
  margin-top:-15px;
  margin-left: 15px;
  border: 1px solid #eee;
  border-radius: 5px;
  width: 80px;
  display: block;
  height: 80px;
  object-fit: cover;
}
.groupShopShar-skuSaleInfo .info{  
  float: left;
  padding: 20px 0 0 15px;
}
.groupShopShar-skuSaleInfo .info .price{  
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color:Red;
}
.groupShopShar-skuSaleInfo .info .skuid{ 
  font-size: 12px;
}
.groupShopShar .modal{
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 10;
  text-align: center;
}
.groupShopShar .modal img.jiantou{
  right: 5%;
  position: absolute;
  width: 20%;
}
.groupShopShar .modal p{
  text-align: center;
  color: #fff;
  margin-top: 30%;
  margin-bottom: 20px;
  font-size: 16px;
}
.groupShopShar .erweima{
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    position: fixed;
    top: 0;
  }
.groupShopShar .erweima .erweima_list{
    position: absolute;
    top: 15%;
    left: 25%;
    width: 50%;
}
.groupShopShar .erweima .erweima_item{
  margin-bottom: 20px;
}
  .groupShopShar .erweima img{
    width: 100%;
  }
  .groupShopShar .erweima .tishi{
    font-size: 12px;
    color: #fff;
    text-align: center;
  }
</style>




// WEBPACK FOOTER //
// src/pages/groupShop/groupShopShar.vue